/*
 * rolex-carousel-a11y.js
 * Shared accessibility layer for slick carousels.
 *  - Injects a visually hidden role="status" live region after each carousel
 *  - Announces the newly displayed slide(s) on change (arrows, dots, swipe)
 *    without moving focus
 *  - Makes every non-visible slide (including infinite-loop clones) inert + aria-hidden
 *
 * Usage (bind BEFORE calling .slick() so the init event is caught):
 *   var $c = $('.my-carousel');
 *   rolexCarouselA11y($c);
 *   $c.slick({ ..., focusOnChange: false });
 *
 * Safe to include more than once per page; also safe to call on an
 * already-initialized carousel.
 */
(function () {
  if (window.rolexCarouselA11y) return;

  // jQuery is resolved when rolexCarouselA11y is called, not when this file loads,
  // so script order in theme.liquid doesn't matter.
  var $;

  var STATUS_CSS =
    'position:absolute;width:1px;height:1px;padding:0;margin:-1px;' +
    'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';

  // Label = slide headings joined with an em dash; falls back to first image alt.
  function slideLabel(slide) {
    var $slide = $(slide);
    var parts = $slide.find('h2, h3').map(function () {
      return $.trim($(this).text());
    }).get().filter(Boolean);

    if (!parts.length) {
      var alt = $.trim($slide.find('img').first().attr('alt') || '');
      if (alt) parts.push(alt);
    }
    return parts.join(' — ');
  }

  // 1-based position of a slide or clone within the real slide set.
  function position(slide, count) {
    var i = parseInt(slide.getAttribute('data-slick-index'), 10);
    return ((i % count) + count) % count + 1;
  }

  // Visible = slick-active, which covers clones shown when an infinite carousel wraps.
  function sync(slick) {
    if (!slick.$slideTrack) return [];
    var visible = slick.$slideTrack.children('.slick-active').get();

    slick.$slideTrack.children().each(function () {
      var shown = visible.indexOf(this) !== -1;
      this.inert = !shown;
      this.setAttribute('aria-hidden', shown ? 'false' : 'true');
      if (!shown) this.setAttribute('tabindex', '-1');
    });
    return visible;
  }

  function announce($status, slick, visible) {
    if (!visible.length) return;

    var total = slick.slideCount;
    var pos = visible.map(function (s) { return position(s, total); });
    var labels = visible.map(slideLabel).filter(Boolean);
    var range;

    if (pos.length === 1) {
      range = 'Slide ' + pos[0] + ' of ' + total;
    } else {
      var contiguous = pos.every(function (p, i) { return i === 0 || p === pos[i - 1] + 1; });
      range = 'Slides ' +
        (contiguous ? pos[0] + ' to ' + pos[pos.length - 1] : pos.join(', ')) +
        ' of ' + total;
    }

    var text = range + (labels.length ? ': ' + labels.join(', ') : '');
    if ($status.text() !== text) $status.text(text);
  }

  window.rolexCarouselA11y = function ($carousels) {
    $ = window.jQuery || window.$;
    if (!$ || !$.fn || !$.fn.slick) {
      console.warn('rolexCarouselA11y: jQuery/slick not available when called');
      return;
    }

    $($carousels).each(function () {
      var $el = $(this);
      if ($el.data('rolexA11y')) return;
      $el.data('rolexA11y', true);

      var $status = $('<div class="rolex-carousel-status" role="status" aria-live="polite" aria-atomic="true"></div>')
        .attr('style', STATUS_CSS);
      $el.after($status);

      // Deferred so it runs after slick's own ADA pass (which fires after afterChange
      // and would otherwise overwrite aria-hidden on wrapped clones).
      function later(fn) {
        return function (e, slick) {
          setTimeout(function () { fn(slick); }, 0);
        };
      }

      $el
        .on('init reInit breakpoint setPosition', later(sync))
        .on('afterChange', later(function (slick) {
          announce($status, slick, sync(slick));
        }))
        .on('destroy', function (e, slick) {
          if (!slick.$slideTrack) return;
          slick.$slideTrack.children().each(function () {
            this.inert = false;
            this.removeAttribute('aria-hidden');
          });
        });

      if ($el.hasClass('slick-initialized')) {
        sync($el.slick('getSlick'));
      }
    });
  };
})();

if (!window.rolexCarouselAnnounceBound) {
  window.rolexCarouselAnnounceBound = true;

  $(document).on('afterChange', '.rolex-hero-carousel-container', function(event, slick, currentSlide) {
    var $slide = slick.$slides.eq(currentSlide);
    var subheading = $.trim($slide.find('.rolex-headline26').first().text());
    var heading = $.trim($slide.find('.rolex-headline50').first().text());
    var label = [subheading, heading].filter(Boolean).join(' — ') || $.trim($slide.find('img').attr('alt') || '');
    var message = 'Slide ' + (currentSlide + 1) + ' of ' + slick.slideCount + (label ? ': ' + label : '');

    $(this).closest('section').find('.rolex-carousel-status').text(message);
  });
}
